import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderSlot as _renderSlot, unref as _unref, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-bad04770"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("label", { class: "pretitle" }, "Scenario"),
  /*#__PURE__*/_createElementVNode("h3", { class: "subtitle" }, "Complete")
], -1))
const _hoisted_2 = /*#__PURE__*/_createTextVNode(" View Details ")
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" Dashboard ")

import ModalComponent from './ModalComponent.vue';
import ButtonComponent from './ButtonComponent.vue';
import Icon from './icon/Icon';
import { RouteNames } from '../router/Routes';


export default /*#__PURE__*/_defineComponent({
  __name: 'ScenarioCompleteModalComponent',
  props: {
  modalActive: {
    required: true,
    type: Boolean,
    default: false
  }
},
  emits: ['toggle', 'reroute', 'viewHistory'],
  setup(__props) {





return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(ModalComponent, {
    onClose: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('toggle'))),
    modalActive: __props.modalActive
  }, {
    title: _withCtx(() => [
      _hoisted_1
    ]),
    body: _withCtx(() => [
      _renderSlot(_ctx.$slots, "content")
    ]),
    navigation: _withCtx(() => [
      _createVNode(ButtonComponent, {
        class: "justify-center w-full",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('reroute', _unref(RouteNames).TRAINING_HISTORY))),
        "data-testid": "dashboard-button",
        "color-type": "secondary",
        "right-icon-value": _unref(Icon).VISIBILITY_LIGHT
      }, {
        default: _withCtx(() => [
          _hoisted_2
        ]),
        _: 1
      }, 8, ["right-icon-value"]),
      _createVNode(ButtonComponent, {
        class: "justify-center w-full",
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('reroute', _unref(RouteNames).STUDENT))),
        "data-testid": "dashboard-button",
        "color-type": "tertiary"
      }, {
        default: _withCtx(() => [
          _hoisted_3
        ]),
        _: 1
      })
    ]),
    _: 3
  }, 8, ["modalActive"]))
}
}

})